import { render } from "./account.vue?vue&type=template&id=110b711a&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=110b711a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-110b711a"

export default script